import { defineColumnInterface } from "../../lib/defines";
import Component from "./component";

export default defineColumnInterface({
  id: "select-dropdown-m2o",
  component: Component,
});
